// extracted by mini-css-extract-plugin
export var card = "_8r-1";
export var container = "_8r-0";